import React from 'react';
import { classes } from '../../Tabs.st.css.js';
const SideContent = ({ content }) => content ? (React.createElement("div", { "data-content": "true", className: classes.sideContent }, content)) : null;
export default SideContent;
//# sourceMappingURL=SideContent.js.map